<app-auth-header [title]="title | translate" [subtitle]="subTitle | translate"></app-auth-header>

<form class="reset-form" [formGroup]="form" (ngSubmit)="onResetClick()">
  <!-- Username -->
  <div class="input-field">
    <label for="reset_user_name" class="field-label"> {{ 'USERS.TABLES.HEADERS.USER_NAME' | translate }} <span class="req">*</span> </label>
    <input
      id="reset_user_name"
      name="reset_user_name"
      type="text"
      pInputText
      class="field-input"
      formControlName="user_name"
      [placeholder]="'USERS.TABLES.HEADERS.USER_NAME' | translate"
      />
    </div>

    <!-- Country code + mobile in one compact row -->
    <div class="input-field">
      <div class="phone-row">
        <div class="country-col">
          <label for="reset_country_code" class="field-label"> {{ 'USERS.FORMS.FIELD_LABELS.COUNTRY_CODE' | translate }} <span class="req">*</span> </label>
          <p-select
            inputId="reset_country_code"
            formControlName="country_code"
            [options]="countries"
            optionValue="country_code"
            optionLabel="country_code"
            [filter]="true"
            filterBy="name_en,name_he,country_code"
            appendTo="body"
            styleClass="country-select"
            [placeholder]="'+972'"
            >
            <ng-template let-country pTemplate="item">
              <span class="country-option">
                <img [src]="country.icon" [alt]="country.name_en" width="22" />
                <b>{{ country.country_code }}</b>
                <span class="country-name">{{ country.name_en }}</span>
              </span>
            </ng-template>
            <ng-template let-country pTemplate="selectedItem">
              @if (country) {
                <span class="country-option">
                  <img [src]="country.icon" [alt]="country.name_en" width="20" />
                  <b>{{ country.country_code }}</b>
                </span>
              }
            </ng-template>
          </p-select>
        </div>
        <div class="mobile-col">
          <label for="reset_mobile" class="field-label"> {{ 'USERS.FORMS.FIELD_LABELS.PHONE_NUMBER' | translate }} <span class="req">*</span> </label>
          <input
            id="reset_mobile"
            name="reset_mobile"
            type="text"
            inputmode="tel"
            pKeyFilter="int"
            maxlength="15"
            pInputText
            class="field-input"
            formControlName="mobile"
            [placeholder]="'USERS.FORMS.FIELD_LABELS.PHONE_NUMBER' | translate"
            />
          </div>
        </div>
      </div>

      <!-- Submit -->
      <button type="submit" class="btn btn-primary lg reset-submit" [disabled]="!isFormValid()">
        {{ 'AUTH.APPLY_RESET.TITLE' | translate }}
      </button>

      <!-- Back to login -->
      <p class="reset-back">
        <a [routerLink]="['../', 'login']">{{ 'AUTH.FOOTER.BACK_TO_LOGIN' | translate }}</a>
      </p>
    </form>
